<template>
  <v-app>
    <v-main>
      <Slider />
      <Services id='services'/>
      <About id='about'/>
      <Equipo id='team'/>
      <Clients id='clients'/>
      <Footer/>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
      <a href="https://web.whatsapp.com/send?l=es&phone=+50769307666"
          class="float"
          target="_blank">
      <i class="fa fa-whatsapp my-float"></i>
      </a>
<!--       <v-fab-transition>
      <v-btn
        :key="activeFab.icon"
        :color="activeFab.color"
        fab
        large
        dark
        bottom
        left
        class="v-btn--example"
      >
        <v-icon>{{ activeFab.icon }}</v-icon>
      </v-btn>
    </v-fab-transition> -->
    </v-main>
  </v-app>
</template>

<script>
import Slider from '@/components/company/SliderServices'
import Clients from '@/components/company/Clients'
import About from '@/components/company/About'
import Services from '@/components/company/Services'
import Footer from '@/components/company/Footer'
import Equipo from '@/components/company/Equipo'
export default {
  name: 'App',
  data: () => ({
    fab: false,
    hidden: false,
    tabs: null
  }),
  components: {
    Slider,
    Clients,
    About,
    Services,
    Footer,
    Equipo
  },
  computed: {
    activeFab () {
      switch (this.tabs) {
        case 'one': return { color: 'success', icon: 'mdi-share-variant' }
        case 'two': return { color: 'red', icon: 'mdi-pencil' }
        case 'three': return { color: 'green', icon: 'mdi-chevron-up' }
        default: return {}
      }
    }
  }
}
</script>

<style scoped>
.float{
  position: fixed;
  width:60px;
  height:60px;
  bottom:40px;
  right:40px;
  background-color:#25d366;
  color:#FFF;
  border-radius:50px;
  text-align:center;
  font-size:30px;
  box-shadow: 2px 2px 3px #999;
  z-index:100;
}

.my-float{
  margin-top:16px;
}

#lateral .v-btn--example {
    bottom: 0;
    position: absolute;
    margin: 0 0 16px 16px;
  }
</style>
